import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  Input,
} from "reactstrap";
import { toast } from "react-toastify";
import { useUserContext } from "libs/context/UserContext";
import {
  candidateConversastionSubmit,
} from "model/CandidateDetailsModel";
import { formatDataBeforeSend } from "helpers/GeneralHelper";

const CandidateConversationModal = ({
  setSidebarConversationOpen,
  sidebarConversationOpen,
}) => {
  const {
    candidateDetailsData,
    setCandidateDetailsData,
    fetchCandidateDetailsDataForUpdate,
  } = useUserContext() || {};

  const [newMessage, setNewMessage] = useState("");
  const inputFields = {};
  const formatOptions = [];
  const [fields] = useState(inputFields);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const closeModal = (e) => {
    e.preventDefault();
    setSidebarConversationOpen(false);
  };

  const sendMessage = () => {
    if (!newMessage.trim()) {
      toast.error("Message cannot be empty");
      return;
    }
    conversationSubmit(newMessage);

    // Optimistic update
    const optimisticMessage = {
      _CandidateConversationId: Date.now(),
      ConversationFrom: "candidate",
      Message: newMessage,
      ConversationTimeRelative: "Just now",
    };

    setCandidateDetailsData((prev) => ({
      ...prev,
      CandidateConversation: [
        ...(prev?.CandidateConversation || []),
        optimisticMessage,
      ],
    }));

    setNewMessage("");
  };

  const conversationSubmit = async (newMessage) => {
    try {
      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      formData.append("ConversationMessage", newMessage);
      let response = await candidateConversastionSubmit(formData);
      if (response?.IsSuccess) {
        toast.success(response?.Message);
        // fetchCandidateDetailsDataForUpdate();
      } else {
        toast.error("Failed to update");
      }
    } catch (err) {
      toast.error(err || "Something went wrong");
    }
  };

  // Auto scroll to latest message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [candidateDetailsData?.CandidateConversation]);

  // Ensure input visible when focusing (mobile keyboards)
  useEffect(() => {
    const input = inputRef.current;
    if (!input) return;

    const handleFocus = () => {
      setTimeout(() => {
        input.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 300);
    };

    input.addEventListener("focus", handleFocus);
    return () => input.removeEventListener("focus", handleFocus);
  }, []);

  return (
    <>
      <Modal
        isOpen={sidebarConversationOpen}
        className="modal-dialog-left modal-full-height"
        backdrop="static"
      >
        <ModalBody
          className="p-0 d-flex flex-column"
        //   style={{ height: "100vh" }}
        style={{ maxHeight: "90vh", overflowY: "auto" }}
        >
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center px-3 py-3 border-bottom bg-white">
            <h5 className="fw-bold mb-0 mx-auto">Conversation</h5>
            <Button close onClick={(e) => closeModal(e)} />
          </div>

          {/* Messages */}
          <div
            className="flex-grow-1 overflow-auto p-3 bg-white d-flex flex-column"
            style={{ minHeight: 0 }}
          >
            {candidateDetailsData?.CandidateConversation?.map((msg) => {
              const isCandidate = msg.ConversationFrom === "candidate";

              return (
                <div
                  key={msg._CandidateConversationId}
                  className={`d-flex mb-3 ${
                    isCandidate ? "justify-content-end padding-move-left" : "justify-content-start"
                  }`}
                  style={{ width: isCandidate ? "100%" : "90%" }}
                >
                  <div
                    className={`p-3 w-100 ${
                      isCandidate ? "bg-secondary text-white" : "bg-light text-dark"
                    }`}
                    style={{
                      borderRadius: "18px",
                      borderTopRightRadius: isCandidate ? "0" : "18px",
                      borderTopLeftRadius: isCandidate ? "18px" : "0",
                    }}
                  >
                    <div><strong>{`${msg?.ConversationFrom=='client' ? `Client :  ` : (msg?.ConversationFrom=='recruiter' ? `Recruiter : ` : '')} `}</strong> {msg.Message}</div>
                    <div
                      className="mt-2 d-flex justify-content-end"
                      style={{ fontSize: "0.8rem" }}
                    >
                      <span
                        className={
                          isCandidate ? "text-white-50" : "text-muted"
                        }
                      >
                       {msg.ConversationTimeRelative}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <div
            className="d-flex p-2 border-top bg-white"
            style={{ position: "sticky", bottom: 0 }}
          >
            <Input
              innerRef={inputRef}
              type="text"
              placeholder="Message"
              value={newMessage}
              name="message"
              onChange={(e) => setNewMessage(e?.target?.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  sendMessage();
                }
              }}
              className="me-2"
            />
            <Button color="dark" onClick={sendMessage}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-send"
                viewBox="0 0 16 16"
              >
                <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z" />
              </svg>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CandidateConversationModal;
